"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var debug = require("debug")("fifi:adminapp");

var AppController = function () {
  /*@ngInject*/
  function AppController($http, Cars, Applications, apps, app, $state, Modal, settings, Fake, EnvironmentConfig, $localStorage) {
    var _this = this;

    _classCallCheck(this, AppController);

    this._Storage = $localStorage;
    debug(this._Storage);

    this.year = this._Storage.year;
    debug(this.year);
    this.type = this._Storage.type;

    this.paymentError = null;

    this._Storage.query = this._Storage.query || {};

    this.randomToggle = false;

    this._Applications = Applications;

    this.yearStart = 1941;
    this.today = new Date();
    this.yearEnd = this.today.getYear() + 1900 + 1;
    this.years = [];
    this.thisYear = this.today.getYear() - 100;
    this.maxExpYear = this.today.getYear() - 60;

    this.appStartYear = 2015;
    this.appYears = [];
    this.seqArray(this.appStartYear, this.yearEnd, this.appYears, false);

    this.exp_months = [];
    this.exp_years = [];

    this.seqArray(this.yearStart, this.yearEnd, this.years, false);
    this.seqArray(0, 12, this.exp_months, true);
    this.seqArray(this.thisYear - 1, this.maxExpYear, this.exp_years, true);
    debug(this.years);
    this.apps = apps;

    this.appStats = {};

    this.randomizeApps();

    this.orderByName = "timestamp";
    this.reverse = true;

    this.app = app;
    this._Modal = Modal;
    this._Cars = Cars;
    this._$state = $state;
    this.settings = {};
    this.label = "label-success";
    if (this.app.vehicle && this.app.vehicle.year) {
      this._Cars.getCarList(this.app.vehicle.year, "").then(function (response) {
        _this.makeList = response;
        _this.modelList = [];
        _this._Cars.getCarList(_this.app.vehicle.year, _this.app.vehicle.make).then(function (res) {
          _this.modelList = res;
          _this.modelList.push("Other");
        });
      });
    }
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = settings[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var setting = _step.value;

        this.settings[setting.name] = setting.value;
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    this.mission;

    if (this._$state.current.name == "admin.new") {
      if (EnvironmentConfig.environment == "development") {
        this.app = Fake.fakeApp();
      }
      this.mission = "new";
      this.app.notes = [];
      this.app.type = "MISC";
      this.checkPrice();
    }

    this.makeList = [];
    this.modelList = [];
  }

  _createClass(AppController, [{
    key: "resetQuery",
    value: function resetQuery() {
      this._Storage.query = {};
    }
  }, {
    key: "randomizeApps",
    value: function randomizeApps() {
      this.appStats = {
        Main: {
          Pending: 0,
          "Wait List": 0,
          Accepted: 0,
          Rejected: 0
        },
        West: {
          Pending: 0,
          "Wait List": 0,
          Accepted: 0,
          Rejected: 0
        },
        Saltaire: {
          Pending: 0,
          "Wait List": 0,
          Accepted: 0,
          Rejected: 0
        }
      };

      for (var index = 0; index < this.apps.length; index++) {
        var element = this.apps[index];
        element.random = Math.random();
        if (element.lot) {
          this.appStats[element.lot][element.status]++;
        }
      }
    }
  }, {
    key: "getApps",
    value: function getApps() {
      var _this2 = this;

      this._Storage.type = this.type;
      this._Storage.year = this.year;
      this._Applications.query({ type: this.type, year: this.year }).then(function (response) {
        debug(response);
        _this2.apps = response;
        _this2.randomizeApps();
      });
    }
  }, {
    key: "getAppReport",
    value: function getAppReport() {
      var _this3 = this;

      this._Storage.type = this.type;
      this._Storage.year = this.year;
      this._Applications.report({ type: this.type, year: this.year }).then(function (response) {
        debug(response);
        _this3.apps = response;
      });
    }
  }, {
    key: "downloadStickerCSV",
    value: function downloadStickerCSV() {
      this._Storage.type = this.type;
      this._Storage.year = this.year;
      return this._Applications.stickers({ type: this.type, year: this.year, update: this.updated }).then(function (response) {
        debug(response);
        return response;
      }).catch(function (err) {
        console.log(err);
      });
    }
  }, {
    key: "checkPrice",
    value: function checkPrice() {
      console.log("Check price");
      this.app.beach = this.app.beach || {};
      if (this.app.type == "MISC") {
        this.label = "label-success";
        this.app.overrideAmount = this.settings.miscPrice;
      } else if (this.app.type == "OB HO") {
        this.label = "label-primary";
        this.app.overrideAmount = this.settings.obhoPrice;
        this.app.beach.community = "OB";
        this.app.beach.type = "Homeowner";
      } else if (this.app.type == "SA HO") {
        this.label = "label-danger";
        this.app.overrideAmount = this.settings.sahoPrice;
        this.app.beach.community = "SA";
        this.app.beach.type = "Homeowner";
      } else if (this.app.type == "OB VILL") {
        this.label = "label-warning";
        this.app.overrideAmount = this.settings.obhoPrice;
        this.app.beach.community = "OB";
        this.app.beach.type = "Village";
      } else if (this.app.type == "SA VILL") {
        this.label = "label-info";
        this.app.overrideAmount = this.settings.sahoPrice;
        this.app.beach.community = "SA";
        this.app.beach.type = "Village";
      }

      if (this.app.vehicle && this.app.vehicle.size === "Oversized") {
        console.log("Oversized", this.settings);
        if (this.app.type == "MISC") {
          this.app.overrideAmount += this.settings.oversizedFee;
        } else {
          this.app.overrideAmount += 100;
        }
      }
    }
  }, {
    key: "exportApps",
    value: function exportApps(apps) {
      var output = [];
      for (var i = 0; i < apps.length; i++) {
        var fee = 22.84;
        if (apps[i].charge.amount == 88578) {
          fee = 25.99;
        }
        var app = {
          timestamp: apps[i].timestamp,
          lot: apps[i].lot,
          appId: apps[i].appId,
          beach: apps[i].beach.community,
          type: apps[i].beach.type,
          firstName: apps[i].name.first,
          lastName: apps[i].name.last,
          chargeId: apps[i].charge.chargeId,
          amountPaid: apps[i].charge.amount / 100,
          fee: fee,
          totalCollected: apps[i].charge.amount / 100 - fee
        };
        output.push(app);
      }
      debug(output);
      return output;
    }
  }, {
    key: "refund",
    value: function refund(mission) {
      var _this4 = this;

      this._Modal.confirmation("Are you sure you want to set the application as " + mission + "?", mission).then(function () {
        _this4.app.newStatus = mission;
        _this4._Applications.refund(_this4.app).then(function (response) {
          _this4.app = response;
        }).catch(function (err) {
          console.log(err);
        });
      });
    }
  }, {
    key: "open",
    value: function open() {
      this.opened = true;
    }
  }, {
    key: "submitForm",
    value: function submitForm(form) {
      var _this5 = this;

      if (form.$valid || this._$state.current.name != "admin.new") {
        this._Applications.save(this.app).then(function () {
          _this5._$state.go("admin.app", { id: _this5.app._id });
        }, function (err) {
          console.log(err);
          _this5.error = err.data.message;
        });
      }
    }
  }, {
    key: "addNote",
    value: function addNote(note) {
      this.app.notes.push(note);
      this.note = "";
    }
  }, {
    key: "deleteNote",
    value: function deleteNote(note) {
      var index = this.app.notes.indexOf(note);
      this.app.notes.splice(index, 1);
    }
  }, {
    key: "pay",
    value: function pay() {
      var _this6 = this;

      this._Modal.payment("", "", this.app).then(function (res) {
        _this6._Applications.payAndAccept(res).then(function (response) {
          _this6.paymentError = null;
          _this6.app = response;
        }).catch(function (err) {
          console.log(err);
          _this6.paymentError = err.data;
        });
      });
    }
  }, {
    key: "payWithStripe",
    value: function payWithStripe(form) {
      var _this7 = this;

      form.$setSubmitted();
      if (form.$valid) {
        this._Modal.payment("", "", this.app).then(function (res) {
          _this7._Applications.manual(res).then(function (response) {
            debug(response);
            _this7._$state.go("admin.app", { id: response._id });
          }).catch(function (err) {
            console.log(err);
          });
        });
      }
    }
  }, {
    key: "payWithNote",
    value: function payWithNote(form) {
      var _this8 = this;

      form.$setSubmitted();
      if (form.$valid) {
        this._Modal.manual("", "", this.app).then(function (res) {
          _this8.app.payment = res;
          _this8.app.payment.amount = _this8.app.overrideAmount * 100;
          _this8._Applications.manual(_this8.app).then(function (response) {
            _this8._$state.go("admin.app", { id: response._id });
          }).catch(function (err) {
            console.log(err);
          });
        });
      }
    }
  }, {
    key: "waitList",
    value: function waitList(form) {
      var _this9 = this;

      form.$setSubmitted();
      if (form.$valid) {
        this._Modal.confirmation("Are you sure you want to submit the application to the wait list?", "Wait List").then(function () {
          _this9._Applications.wait(_this9.app).then(function (response) {
            _this9._$state.go("admin.app", { id: response._id });
          }).catch(function (err) {
            console.log(err);
          });
        });
      }
    }
  }, {
    key: "sendId",
    value: function sendId(app) {
      var _this10 = this;

      console.log(app);
      this._Modal.confirmation("Are you sure you want to send the Homeowner Id to the email on file?", "Send Homeowner ID").then(function () {
        _this10._Applications.sendId(app._id).then(function (response) {
          console.log(response);
          console.log("Sent");
        }).catch(function (err) {
          console.log(err);
        });
      });
    }
  }, {
    key: "mailingList",
    value: function mailingList() {
      var _this11 = this;

      if (this.app.name.first && this.app.name.last && this.app.address.line1 && this.app.address.city && this.app.address.zip && this.app.address.state) {
        this.mailingListError = "";
        this._Modal.confirmation("Are you sure you want to submit the application to the mailing list?", "Mailing List").then(function () {
          _this11._Applications.mailingList(_this11.app).then(function (response) {
            _this11._$state.go("admin.app", { id: response._id });
          }).catch(function (err) {
            console.log(err);
          });
        });
      } else {
        this.mailingListError = "You must enter at least the name and address!";
      }
    }
  }, {
    key: "seqArray",
    value: function seqArray(start, end, array, dir) {
      for (var i = end; i > start; i--) {
        if (dir) {
          array.unshift(i.toString());
        } else {
          array.push(i.toString());
        }
      }
      return array;
    }
  }, {
    key: "acceptModal",
    value: function acceptModal(app) {
      var _this12 = this;

      this._Modal.accept("Are you sure you want to accept this application?", "Accept and Capture", app).then(function (res) {
        console.log(res);
        var index = _this12.apps.indexOf(app);
        _this12.apps[index] = res;
      }).catch(function (err) {
        console.log(err);
      });
    }
  }, {
    key: "acceptOther",
    value: function acceptOther(form) {
      var _this13 = this;

      debug(form);
      this._Modal.acceptOther("", "", this.app).then(function (res) {
        _this13.app.payment = res;
        _this13._Applications.acceptSpecial(_this13.app).then(function (response) {
          _this13.app = response;
        }).catch(function (err) {
          console.log(err);
        });
      });
    }
  }, {
    key: "acceptCapture",
    value: function acceptCapture() {
      var _this14 = this;

      this._Modal.confirmation("Are you sure you want to accept this application?", "Accept and Capture").then(function () {
        _this14._Applications.capture(_this14.app).then(function (response) {
          _this14.app = response;
        }).catch(function (err) {
          console.log(err);
        });
      });
    }
  }, {
    key: "updateCars",
    value: function updateCars(mode) {
      var _this15 = this;

      if (mode == "year") {
        this.modelList = [];
        this.makeList = [];
        this.app.vehicle.make = null;
        this.app.vehicle.model = null;
      }
      this._Cars.getCarList(this.app.vehicle.year, this.app.vehicle.make).then(function (response) {
        if (mode === "year") {
          _this15.makeList = response;
          _this15.modelList = [];
        } else {
          _this15.modelList = response;
          _this15.modelList.push({ model: "Other", oversized: false });
        }
      });
    }
  }, {
    key: "updateVehicleInfo",
    value: function updateVehicleInfo() {
      if (this.app.vehicle.raw) {
        this.app.vehicle.model = this.app.vehicle.raw.model;
        this.app.vehicle.size = this.app.vehicle.raw.oversized ? "Oversized" : "Normal";
      }
      this.checkPrice();
    }
  }]);

  return AppController;
}();

exports.default = AppController;


// WEBPACK FOOTER //
// ./client/app/admin/app.controller.js